(() => {
  const isDesktop = () =>
    !!(window.theme && window.theme.mediaMatches && window.theme.mediaMatches.md);

  const handleScroll = () => {
    document.body.classList.toggle(
      "scrolled-to-bottom",
      window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
    );
  };

  function getDesktopTrigger(productSection) {
    const productForm = productSection.querySelector("product-form");
    if (!productForm) return null;

    // Meest betrouwbare desktop-trigger: de echte add-to-cart knop in/naast het form
    return (
      productForm.querySelector('[type="submit"], button[name="add"], .product-form__submit') ||
      productForm
    );
  }

  function setPanelState(el, productSection) {
    const productForm = productSection.querySelector("product-form");
    const mobileTrigger = productForm; // mobiel: hele form

    const desktopTrigger = getDesktopTrigger(productSection); // desktop: knop (of fallback form)

    const trigger = isDesktop() ? desktopTrigger : mobileTrigger;
    if (!trigger) {
      // Safe default: hidden
      el.classList.add("sticky-atc-panel--out");
      return;
    }

    const rect = trigger.getBoundingClientRect();

    // Verberg zolang de trigger nog in beeld is; toon zodra trigger "boven" viewport is
    // (kleine marge zodat het natuurlijker voelt)
    const shouldHide = rect.bottom > 40;

    el.classList.toggle("sticky-atc-panel--out", shouldHide);
  }

  function initStickyAtcPanel(el) {
    const productSection = el.closest(".cc-main-product") || document;

    // Start altijd hidden; daarna bepalen we state op basis van scroll/positie
    el.classList.add("sticky-atc-panel--out");
    el.classList.remove("invisible");
    el.classList.remove("sap--init-hidden");

    const update = () => {
      handleScroll();
      setPanelState(el, productSection);
    };

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update, { passive: true });

    // Initial state (zonder wachten op observer/scroll)
    update();
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-sticky-atc-panel]").forEach(initStickyAtcPanel);
  });

  document.addEventListener("click", (e) => {
    const t = e.target.closest(".sap__thumb");
    if (!t) return;
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
})();
